"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CATEGORY_PAGE = void 0;
const CATEGORY_PAGE = exports.CATEGORY_PAGE = 'category-page';
